import React from "react";
import { Carousel } from "react-bootstrap";
import "./ProjectCard.css";

const ProjectCard = (props) => {
  const {
    title,
    description,
    technology,
    img_1,
    img_2,
    img_3,
    liveSite,
    clientGithub,
    serverGithub,
  } = props.project;

  return (
    <section className="row projectCard p-3">
      <div className="projectCardText col-md-6 d-flex flex-column justify-content-around">
        <h2>{title}</h2>
        <p>{description}</p>
        <div className="row">
          {technology.map((tech) => {
            return (
              <div key={tech} className="skill">
                <span>{tech}</span>
              </div>
            );
          })}
        </div>
        <div className="my-3 d-flex justify-content-around ">
          <div className="">
            <a target="_blank" href={liveSite}>
              <h6 className="text-danger ">WebSite</h6>
            </a>
          </div>
          {clientGithub && (
            <div className="">
              <a target="_blank" href={clientGithub}>
                <h6 className="text-danger">Client Github</h6>
              </a>
            </div>
          )}
          {serverGithub && (
            <div className="">
              <a target="_blank" href={serverGithub}>
                <h6 className="text-danger">Server Github</h6>
              </a>
            </div>
          )}
        </div>
      </div>
      <div className="col-md-6 my-3">
        <Carousel>
          <Carousel.Item>
            <img
              style={{ maxWidth: "100%", maxHeight: "20%" }}
              src={img_1}
              alt=""
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              style={{ maxWidth: "100%", maxHeight: "50%" }}
              src={img_2}
              alt=""
            />
          </Carousel.Item>
          <Carousel.Item>
            <img
              style={{ maxWidth: "100%", maxHeight: "50%" }}
              src={img_3}
              alt=""
            />
          </Carousel.Item>
        </Carousel>
      </div>
    </section>
  );
};

export default ProjectCard;
